import { useTheme } from "@mui/material";
import { Box, Link, Text } from "designSystem/index";
import { TextProps } from "designSystem/components/text/Text";
import React, { FunctionComponent } from "react";
import { useMessageStyles } from "./styles";

interface UnsupportedBlockProps {
	/** the actual link for the text */
	link: string;

	/** properties for the text */
	linkTextProps: TextProps;
}

const UnsupportedBlock: FunctionComponent<UnsupportedBlockProps> = (props) => {
	const classes = useMessageStyles(useTheme());
	const { link, linkTextProps } = props;

	return (
		<Box sx={classes.unsupported}>
			<Text block res="UnsupportedMessageText" />
			<Link href={link} target="_blank">
				<Text {...linkTextProps} />
			</Link>
		</Box>
	);
};

export default UnsupportedBlock;